import { language } from 'shared/language';

export const BUILDING_CONFERENCE_CAN_NOT_UPDATE = language.can_not_update_this_meeting;
export const BUILDING_CONFERENCE_ALREADY_EXISTS = language.the_meeting_has_already_existed_in_this_period_time;
export const BUILDING_CONFERENCE_CAN_NOT_DELETE = language.can_not_delete_this_meeting;
export const BUILDING_CONFERENCE_CAN_NOT_UPDATE_STATUS = language.can_not_update_status_this_meeting;
